/** Sidebar nav badge value — undefined hides the badge. */
export function navBadge(count: number): number | undefined {
  return count > 0 ? count : undefined;
}
